import { render } from "./OrderListCard.vue?vue&type=template&id=3e99c39e&scoped=true"
import script from "./OrderListCard.vue?vue&type=script&lang=ts"
export * from "./OrderListCard.vue?vue&type=script&lang=ts"

import "./OrderListCard.vue?vue&type=style&index=0&id=3e99c39e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e99c39e"

export default script